import { format, parseISO } from "date-fns";
import { FC } from "react";
import { UseFormGetValues } from "react-hook-form";

import { AddCaseProps } from "src/pages/addCase/types";


export type DiureticsInformationProps = {
  getValues: UseFormGetValues<AddCaseProps>;
};



const ShowDiureticsInformation: FC<DiureticsInformationProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes: { cp_diuretics } } = getValues()

  return (
    <div className="card">
      <div className="card-header">
        <h1 className="m-0">Current and Prior Diuretics</h1>
      </div>
      <div className={"card-body"}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Furosemide:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.furosemide_props && cp_diuretics.diuretics_tried.furosemide_props ? 
                  [
                    cp_diuretics.diuretics_tried.furosemide_props["20mg"] ? "20mg" : null, 
                    cp_diuretics.diuretics_tried.furosemide_props["40mg"] ? "40mg" : null, 
                    cp_diuretics.diuretics_tried.furosemide_props["80mg"] ? "80mg" : null,
                    cp_diuretics.diuretics_tried.furosemide_props.other_dosage_value &&
                    cp_diuretics.diuretics_tried.furosemide_props.other_dosage_value !== '0' ? 
                      `${cp_diuretics.diuretics_tried.furosemide_props.other_dosage_value}mg` : null
                  ].filter((item) => item !== null).join(",").replace(/^,+|,+$/g, '')
                  : "N/A"
                }</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Result of Use:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.furosemide_props ? cp_diuretics.diuretics_tried.furosemide_props.result_of_use : "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.furosemide_props && cp_diuretics.diuretics_tried.furosemide_props.result_of_use ? (
              cp_diuretics.diuretics_tried.furosemide_props.result_of_use === "Resulted in hospitalization" && cp_diuretics.diuretics_tried.furosemide_props.hospitalization_date ? (
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>Hospitalization Date:</p>
                  </div>
                  <div className="col-6">
                    <p>{format(parseISO(cp_diuretics.diuretics_tried.furosemide_props.hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                  </div>
                </div>
                ) : 
                cp_diuretics.diuretics_tried.furosemide_props.result_of_use.toLowerCase() === "other" ? (
                  <div className="row">
                    <div className="col-6 text-end px-3">
                      <p>Other:</p>
                    </div>
                    <div className="col-6">
                      <p>{cp_diuretics.diuretics_tried.furosemide_props.other || "N/A"}</p>
                    </div>
                  </div>
                ) : null
            ) : null}

          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Torsemide:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.torsemide_props ? 
                  [
                    cp_diuretics.diuretics_tried.torsemide_props["5mg"] ? "5mg" : null,
                    cp_diuretics.diuretics_tried.torsemide_props["10mg"] ? "10mg" : null,
                    cp_diuretics.diuretics_tried.torsemide_props["20mg"] ? "20mg" : null, 
                    cp_diuretics.diuretics_tried.torsemide_props["40mg"] ? "40mg" : null,
                    cp_diuretics.diuretics_tried.torsemide_props["60mg"] ? "60mg" : null,
                    cp_diuretics.diuretics_tried.torsemide_props["100mg"] ? "100mg" : null,
                    cp_diuretics.diuretics_tried.torsemide_props.other_dosage_value && 
                    cp_diuretics.diuretics_tried.torsemide_props.other_dosage_value !== '0' ? 
                      `${cp_diuretics.diuretics_tried.torsemide_props.other_dosage_value}mg` : null,
                  ].filter((item) => item !== null).join(",").replace(/^,+|,+$/g, '')
                  : "N/A"
                }</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Result of Use:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.torsemide_props ? cp_diuretics.diuretics_tried.torsemide_props.result_of_use : "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.torsemide_props ? (
              cp_diuretics.diuretics_tried.torsemide_props.result_of_use === "Resulted in hospitalization" && cp_diuretics.diuretics_tried.torsemide_props.hospitalization_date ? (
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>Hospitalization Date:</p>
                  </div>
                  <div className="col-6">
                    <p>{format(parseISO(cp_diuretics.diuretics_tried.torsemide_props.hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                  </div>
                </div>
                ) : 
                cp_diuretics.diuretics_tried.torsemide_props.result_of_use?.toLowerCase() === "other" ? (
                  <div className="row">
                    <div className="col-6 text-end px-3">
                      <p>Other:</p>
                    </div>
                    <div className="col-6">
                      <p>{cp_diuretics.diuretics_tried.torsemide_props.other || "N/A"}</p>
                    </div>
                  </div>
                ) : null
            ) : null}

          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Bumetanide:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.bumetanide_props ? 
                  [
                    cp_diuretics.diuretics_tried.bumetanide_props["05mg"] ? "0.5mg" : null,
                    cp_diuretics.diuretics_tried.bumetanide_props["1mg"] ? "1mg" : null,
                    cp_diuretics.diuretics_tried.bumetanide_props["2mg"] ? "2mg" : null,
                    cp_diuretics.diuretics_tried.bumetanide_props["3mg"] ? "3mg" : null,
                    cp_diuretics.diuretics_tried.bumetanide_props["4mg"] ? "4mg" : null,
                    cp_diuretics.diuretics_tried.bumetanide_props.other_dosage_value &&
                    cp_diuretics.diuretics_tried.bumetanide_props.other_dosage_value !== '0' ? 
                      `${cp_diuretics.diuretics_tried.bumetanide_props.other_dosage_value}mg` : null,
                  ].filter((item) => item !== null).join(",").replace(/^,+|,+$/g, '')
                  : "N/A"
                }</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Result of Use:</p>
              </div>
              <div className="col-6">
                <p>{cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.bumetanide_props ? cp_diuretics.diuretics_tried.bumetanide_props.result_of_use : "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {cp_diuretics && cp_diuretics.diuretics_tried && cp_diuretics.diuretics_tried.bumetanide_props ? (
              cp_diuretics.diuretics_tried.bumetanide_props.result_of_use === "Resulted in hospitalization" && cp_diuretics.diuretics_tried.bumetanide_props.hospitalization_date ? (
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>Hospitalization Date:</p>
                  </div>
                  <div className="col-6">
                    <p>{format(parseISO(cp_diuretics.diuretics_tried.bumetanide_props.hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                  </div>
                </div>
                ) : 
                cp_diuretics.diuretics_tried.bumetanide_props.result_of_use?.toLowerCase() === "other" ? (
                  <div className="row">
                    <div className="col-6 text-end px-3">
                      <p>Other:</p>
                    </div>
                    <div className="col-6">
                      <p>{cp_diuretics.diuretics_tried.bumetanide_props.other || "N/A"}</p>
                    </div>
                  </div>
                ) : null
            ) : null}

          </div>
        </div>
      </div>

      <div className="card m-3 mt-0">
        <div className="card-header">
          <h1 className="m-0">Lab Values</h1>
        </div>
        <div className={"card-body"}>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-8 text-end px-3">
                  <p>Estimated Creatinine Clearance:</p>
                </div>
                <div className="col-4">
                  <p>
                    {cp_diuretics && cp_diuretics.creatinine_clearance
                        ? `${cp_diuretics.creatinine_clearance} mL/min`
                        : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-8 text-end px-3">
                  <p>Estimated Glomerular Filtration Rate (eGFR):</p>
                </div>
                <div className="col-4">
                  <p>
                    {cp_diuretics && cp_diuretics.eGFR
                        ? `${cp_diuretics.eGFR} mL/min/1.73 m²`
                        : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShowDiureticsInformation;
